import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { WfdPriorityTypeValue } from '../../../enums/wfd-priority.enum';
import { WfdReferralChipComponent } from '../referral-chip.component';
import { WfdVipChipComponent } from '../vip-chip.component';
import { WfdReturnerChipComponent } from '../returner-chip.component';
import { NgClass } from '@angular/common';
import { Owner } from 'src/app/shared/helpers/owner.decorator';

@Owner('Stat-Force 1')
@Component({
    selector: 'nova-wfd-priority-returner-chips-view',
    standalone: true,
    imports: [NgClass, MatChipsModule, WfdReferralChipComponent, WfdVipChipComponent, WfdReturnerChipComponent],
    templateUrl: './priority-returner-view.component.html',
    styleUrls: ['./priority-returner-view.component.scss']
})
export class WfdPriorityReturnerChipsViewComponent {
    @Input() wfdPriority: WfdPriorityTypeValue = WfdPriorityTypeValue.None;
    @Input() isWfdReturner = false;
    @Input() displayVertical = false;

    WfdPriorityTypeValue = WfdPriorityTypeValue;
}
